import { defineMessages } from 'react-intl';

/** Copy owned by the shared Work/Evidence queue list UI. */
export const queuedMessageListMessages = defineMessages({
  queuedCount: {
    defaultMessage: '{count, plural, one {# queued message} other {# queued messages}}',
    id: '2A6sJjvPrh',
    description: 'Header showing how many composer messages are queued',
  },
  expandQueueAria: {
    defaultMessage: 'Expand queued messages',
    id: 'efey1rtQ6P',
    description: 'Aria label for expanding the composer queue list',
  },
  collapseQueueAria: {
    defaultMessage: 'Collapse queued messages',
    id: 'iSWAp7hVvG',
    description: 'Aria label for collapsing the composer queue list',
  },
  sendNow: {
    defaultMessage: 'Send now',
    id: '8zB/g2Kg6k',
    description: 'Send a queued message immediately',
  },
  sendNowAria: {
    defaultMessage: 'Send now',
    id: 'Sn5RSNjhlY',
    description: 'Aria label for sending a queued message now',
  },
  remove: {
    defaultMessage: 'Remove',
    id: '5GzIxcAeVE',
    description: 'Remove a message from the composer queue',
  },
  removeFromQueueAria: {
    defaultMessage: 'Remove from queue',
    id: 'vWeJWxi0WG',
    description: 'Aria label for removing a queued message',
  },
  clearAll: {
    defaultMessage: 'Clear all',
    id: 'jCkjeNPUHN',
    description: 'Clear all queued composer messages',
  },
  clearAllAria: {
    defaultMessage: 'Clear all queued messages',
    id: 'JX0SHFQxK0',
    description: 'Aria label for clearing the composer queue',
  },
  edit: {
    defaultMessage: 'Edit',
    id: 'OT2ILsWwwS',
    description: 'Aria label for editing a queued chat message',
  },
  editTooltip: {
    defaultMessage: 'Edit message',
    id: 'E6zdnze7sT',
    description: 'Tooltip for editing a queued chat message',
  },
  moveUp: {
    defaultMessage: 'Move up',
    id: 'iFOAO3JNlC',
    description: 'Aria label for moving a queued message earlier in the queue',
  },
  moveUpTooltip: {
    defaultMessage: 'Move up in queue',
    id: 'SY2Dsot3x2',
    description: 'Tooltip for promoting a queued message to earlier in the queue',
  },
  autoSend: {
    defaultMessage: 'Auto-send',
    id: 'QYefMNcVOi',
    description: 'Label for the queue auto-send toggle',
  },
  autoSendOnTooltip: {
    defaultMessage:
      'Queued messages will send automatically when the current response completes',
    id: 'x1bdn9U2Y2',
    description: 'Tooltip shown when queue auto-send is enabled',
  },
  autoSendOffTooltip: {
    defaultMessage: 'Messages will stay queued until you send them manually',
    id: '14tgMOXu75',
    description: 'Tooltip shown when queue auto-send is disabled',
  },
  save: {
    defaultMessage: 'Save',
    id: 'FBWAUNf3hh',
    description: 'Save edits to a queued chat message',
  },
  cancel: {
    defaultMessage: 'Cancel',
    id: '+Z5163sfCX',
    description: 'Cancel editing a queued chat message',
  },
});
